/* eslint-disable jsx-a11y/iframe-has-title */
import { useCallback, useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from 'react-redux';
import ContentLoader from 'react-content-loader'
import VideoPlayer from "react-video-js-player";
import CONFIG from "../../utils/config";
import { markModuleProgressUtils, SessionKeys } from "../../utils/AppUtils";
// import ReactPDF from from 'react-pdf';
import _ from "lodash";
// import $ from "jquery";
// import FileViewer from "react-file-viewer";

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Pdftron from "./Pdftron";
import { videoEvents } from "../../utils/VideoClickStream";
import { markModuleProgress } from "../../redux/courses/actions";
import useLogin from "../../custom-hooks/useLogin";
import ArticleComp from "../../finwell/components/launch/ArticleComp";
import AudioPlayerComp from "../../finwell/components/launch/AudioPlayerComp";
import PDFViewer from "../../finwell/components/PDFViewer";
import YoutubePlayer from "../../finwell/components/player/YoutubePlayer";
import VimeoPlayer from "../../finwell/components/player/VimeoPlayer";
import { Button } from "react-bootstrap";
export const ModuleComp = (props) => {

    const {
        mId,
        courseId,
        fetchDataFromIframe,
        openFavourites,
        refer,
        moduleInfo,
        setIsLoad,
        isLoad,
        isModuleChange,
        reload,
        setIsLoading,
        purchasedInfo,
        assetId,
        moduleData
    } = props;

  

    const {isLoggedIn} = useLogin();
    const [iframeHeight, setIframeHeight] = useState(600)
    const [iframeMinHeight, setIframeMinHeight] = useState(600);
    const dispatch = useDispatch()
    const moduleListingData = useSelector(state => {
        return state.courses.moduleListing
    });
    const moduleListingDataBroker = useSelector(state => state.courses.moduleListingBroker);
    const authBroker = useSelector(state => state.auth.authBroker)
    // const [selectedModule, setSelectedModule] = useState(history.location.state.module);
    const search = window.location.search;
    const params = new URLSearchParams(search);

    const c = params.get("c");
	let decodedString = atob(c);
	let paramsReq = JSON.parse(decodedString);
    const source = paramsReq.source;
    const via_lp = paramsReq.via_lp;
    const lp_id = paramsReq.lp_id;
    const via_cat = paramsReq.via_cat;
    const cat_id = paramsReq.catId;
    const level_id = paramsReq.level_id;
    const is_level = paramsReq.is_level;
    const cid = paramsReq.cid;
    const from = paramsReq.from;
    const lp_source = paramsReq.lp_source;

//     const source = params.get('source');
    
//   const cid = params.get("cid");
//   const via_lp = params.get('via_lp');
//   const lp_id = params.get('lp_id');
//   const via_cat = params.get('via_cat');
//   const cat_id = params.get('cat_id');
//   const level_id = params.get('level_id');
//   const is_level = params.get('is_level');
//   const from = params.get('from')
//   const lp_source = params.get("lp_source");

    const playerRef = useRef(null);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [moduleDataInfo, setModuleDataInfo] = useState({})
    const [scormURL, setScormURL] = useState('')
    const [currentTime,setCurrentTime] = useState(0);
    const [duration,setDuration] = useState(0);



    useEffect(() => {
        console.log(moduleInfo)
        // alert(JSON.stringify(purchasedInfo))
        if (!_.isEmpty(moduleInfo)) {
            setModuleDataInfo(moduleInfo)
            if (source === 'broker' || !_.isEmpty(purchasedInfo)) {
                let sURL = "";
                if (source === 'xsel' || source === 'ecom') {
                    sURL = `${CONFIG.SCORM_URL}?course_id=${courseId}&module_id=${mId}&token=${localStorage.getItem(SessionKeys.API_TOKEN_BROKER)}`
                    if (_.toNumber(lp_id) && (from==="lp" || via_lp==="true")) {
                        sURL = sURL + `&lp_id=${lp_id}`
                    }
                    if(purchasedInfo?.is_purchased){
                        sURL = sURL + `&isPaid=true`
                    }else{
                        sURL = sURL + `&isPaid=false`
                    }
                    
                    if(purchasedInfo?.selling_price === 0){
                        sURL = sURL + `&isFree=true`
                    }else{
                        sURL = sURL + `&isFree=false`
                    }
                        
                } else {
                    sURL = `${CONFIG.SCORM_URL_BROKER}?course_id=${courseId}&module_id=${mId}&output=embed`
                    if (_.toNumber(lp_id) && (from === "lp" || via_lp==="true")) {
                        sURL = sURL + `&lp_id=${lp_id}`
                    }
                }
                if(assetId==="4"){
                    setScormURL(moduleInfo?.external_link)
                } else if (isLoggedIn) {
                    let userId = authBroker?.payload?.user?.user_id;
                    let email = authBroker?.payload?.user?.email
                    sURL= sURL + `&email=${email}&user_id=${userId}`
                    setScormURL(sURL)
                } else {
                    setScormURL(sURL)
                }
                console.log('SCORM URL', sURL)
            }
        }
    }, [moduleInfo, authBroker, isLoggedIn, purchasedInfo])

    // const moduleCallBack = useCallback(() => {
    //     if (!_.isEmpty(moduleInfo)) {
    //         setModuleDataInfo(moduleInfo)
    //     }
    // }, [moduleInfo])

    useEffect(() => {
        console.log('SCORM IURL ', scormURL)
    }, [scormURL])

    useEffect(() => {
        if (isLoad) {
            console.log('reset height')
            setIframeHeight(600)
        }
    }, [isLoad])

    useEffect(() => {
        if (isModuleChange) {
            setModuleDataInfo({})
        }
    }, [isModuleChange])

    useEffect(() => {
        if (!_.isEmpty(moduleListingData)) {
            setIframeHeight(600)
        }
    }, [moduleListingData])

    useEffect(() => {
        if (iframeHeight < iframeMinHeight) {
            setIframeMinHeight(iframeHeight)
        }
    }, [iframeHeight])

    useEffect(() => {
        if (!_.isEmpty(moduleInfo)) {
            window.addEventListener("message", handleNotes)
            window.addEventListener("message", favourites)
            window.addEventListener("message", scrollToSection)
            window.addEventListener("message", heightChange)
        }

        return () => {
            window.removeEventListener("message", handleNotes)
            window.removeEventListener("message", favourites)
            window.removeEventListener("message", heightChange)
            window.removeEventListener("message", scrollToSection)
        }
    }, [moduleInfo])

    useEffect(() => {
        console.log('MODULE COMP')
    },[])

    const handleNotes = evt => {
        console.log('event', evt)
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        if (dataObj && dataObj.method === 'notes') {
            console.log('NOTES CLICKED', dataObj, evt)
            dataObj.url = evt.origin;
            fetchDataFromIframe(dataObj);
        }

    }

    const heightChange = evt => {
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        if (dataObj && dataObj.method === 'heightChange') {
            // console.log('heightChange: ', dataObj)
            if (dataObj.height > iframeMinHeight) {
                setIframeHeight(dataObj.height)
            }
            if (dataObj.scrollTop) {
                window.scrollTo(0,0)
            }
        }
    }

    const favourites = evt => {
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        // console.log("Favourites method data---->", dataObj)
        if (dataObj && dataObj.method === 'favourites') {
            openFavourites(dataObj);
            // console.log("open favvv",openFavourites)
            // window.captureMyEvents("favouriteAdded", {
            //   mid: currentModule.module_id,
            //   sid: dataObj.sectionId,
            // });       
        }

    }

    const scrollToSection = (evt) => {
        // console.log('eventScroll', evt)
        let dataObj = typeof evt.data === 'object' ? evt.data : JSON.parse(evt.data);
        // console.log(dataObj.method);
        if (dataObj && dataObj.method === 'contentScrollTo') {
            // console.log('scroll to', dataObj)
            window.scrollTo({
                top: dataObj.topPosition + document.getElementById("scorm_player").offsetTop / 2,
                behavior: 'smooth'
            })
        }
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const setLoadFalse = () => {
        setTimeout(() => {
            setIsLoad(false)
        }, 500)
    }

    const markProgress = () => {
        return;
    }

    var timeCurrent = 0;
    var timeDuration = 0;
    const onPlayerReady = (player, type) => {
        // console.log("Player is ready: ", player);
        // splayer;
         playerRef.current = player;
        const trackEl = player.addRemoteTextTrack(
            {
                // src: 'https://rsplearning-dev.niit-mts.com/public/leadersedgetraining_advertising_and_privacy.webvtt',
                kind: "captions",
                srclang: "en",
                label: "English"
            },
            false
        );
        trackEl.addEventListener('load', function () {
            // your callback goes here
        });

        videoEvents(player, {
            type: 'module',
            course_id: courseId,
            module_id: mId,
            user_id: authBroker?.payload?.user?.user_id
        })

         // Get duration when metadata is loaded
    player.on('loadedmetadata', () => {
      console.log("time duration: ",parseInt(player.duration()));
      let duration = parseInt(player.duration()); 
      sessionStorage.setItem("duration",duration);
      timeDuration = duration;
        setDuration(duration);
    });

    // Listen for time updates
    player.on('timeupdate', () => {
      console.log("time current: ",parseInt(player.currentTime()));
      let current = parseInt(player.currentTime())
      sessionStorage.setItem("current",current);
      timeCurrent = current;
      setCurrentTime(current);
    });

        player.on('ended', () => {
            if (isLoggedIn) {
                setIsLoading(true)
                markModuleProgressUtils(dispatch,mId,courseId,source,type,from,via_lp,lp_id);
                // let reqBody = {
                //     module_id: mId,
                //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                //     course_id: courseId,
                //     source:source==='broker'?"broker":"xsel",
                //     type: type
                //   }
                //   console.log("is_purchased in modulecomp",purchasedInfo)
              
                //   if(from==="lp" || via_lp ==="true"){
                //     reqBody.lp_id = lp_id;
                //   }
              
                // dispatch(
                //     markModuleProgress({
                //         module: "markModuleProgress",
                //         postData: reqBody,
                //     })
                // );

                

            }
        })
    }

    useEffect(()=>{
        if(moduleData){
            console.log("timeC: ",moduleData);
                if (playerRef.current) {
                    playerRef.current.currentTime(moduleData?.watch_time); // Seek to 30 seconds
                } 
        }
    },[playerRef.current,moduleData])

    useEffect(()=>{
        const interval = setInterval(() => {
      callSaveProgressApi();
    }, 10000);
    return () => {
        callSaveProgressApi();
        clearInterval(interval);
    };
  },[])

  const callSaveProgressApi = () => {

     const currentValue = sessionStorage.getItem("current");
        if (currentValue === undefined || currentValue === null || currentValue === "") {
            return;
        }

      // Replace with your actual token logic
      const token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
      // Use the latest currentTime and duration values
      const payload = {
        token,
        course_id: courseId,
        module_id: mId,
        watch_time: parseInt(sessionStorage.getItem("current")),
        duration: parseInt(sessionStorage.getItem("duration"))
      };
      console.log("currentTimeOnBack", timeCurrent, timeDuration);
      sessionStorage.removeItem("current");
    //   sessionStorage.removeItem("duration");

      fetch(CONFIG.API_URL_REAL_BROKER+"wp-json/finwell/v1/save-progress", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(data => {
          console.log("Progress saved:", data);
        })
        .catch(err => {
          console.error("Error saving progress:", err);
        });

  }

  const onProgress =(currentTime,duration)=>{
    console.log("onProgress ",currentTime,duration)
    let current = parseInt(currentTime)
      sessionStorage.setItem("current",current);

      let durationTotal = parseInt(duration); 
      sessionStorage.setItem("duration",durationTotal);
  }

  const onComplete = ()=>{
    console.log("onComplete ")
markModuleProgressUtils(dispatch,mId,courseId,source,"external_link",from,via_lp,lp_id);
  }
    
    return (
        <div className="rowd mb-2 d-flex" aria-hidden="false">
            {(isLoad) ?
                <div className="pt-5 loader-launch">
                    {[...Array(4)].map((el, index) => <ContentLoader key={index} backgroundColor={'#dadada'}
    foregroundColor={'#c4c4c4'} className="pt-2 w-100" />)}
                </div> 
            : null}
            {(!_.isEmpty(moduleInfo) && moduleInfo?.file_type === 'external_link') ||(!_.isEmpty(moduleDataInfo) && moduleDataInfo?.rsp_scromdata[0]?.type === "xlsx")?<>
                {
                    setLoadFalse()
                }
                {moduleInfo?.external_link &&<div className="w-100 d-flex justify-content-center"> <a className="btn btn-primary btn-block next-course-btn cursor-pointer d-flex align-items-center mt-2" onClick={() => { window.open(moduleInfo?.external_link, "_blank") }} >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="rgba(255,255,255,1)"><path d="M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z"></path></svg>
                            <span className="ms-2">Click to Launch</span>
                        </a></div>}
                </>
                :!_.isEmpty(moduleInfo) && (moduleInfo?.file_type === 'mp3' || moduleInfo?.external_type === 'mp3')?
                <AudioPlayerComp setLoadFalse={setLoadFalse} link={moduleInfo?.external_link} moduleId={mId} courseId = {courseId} watch_time={moduleData?.watch_time}/>
                :!_.isEmpty(moduleInfo) && !_.isEmpty(moduleData) && moduleInfo?.file_type === 'article'?
                <ArticleComp title={moduleInfo?.title} content={moduleInfo?.desc} banner={moduleInfo?.module_banner} tagsArray={[moduleInfo?.asset_name,moduleInfo?.monitoring_name,moduleData?.pillar_name,moduleData?.categoryName[0]]} isLoading={isLoad} setLoadFalse={setLoadFalse} moduleData={moduleData} />
                :!_.isEmpty(moduleDataInfo) && ((source === 'xsel' || source === 'ecom') && (moduleInfo?.file_type === 'url' || moduleInfo?.file_type === 'scorm'))
                && reload
                ?
                    (<div className="scrom-wrapr"><iframe
                        key={mId}
                        type="text/html"
                        className="w-100 ms-auto me-auto"
                        id="scorm_player"
                        height={iframeHeight}
                        //style={{ minHeight: iframeMinHeight, width: "70%", margin: "0 auto" }}
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); }}
                        ref={refer}
                        // src="https://jba-learn-dev.niit-mts.com/scorm_player.php?course_id=jbc_hr_od&module_id=jbc_hr_od_m1"
                        // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657078/launch.html?crscd=CSCD_58"
                        // src={`https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=${courseId}&module_id=${mId}&username=${username}`}
                        // src={
                        //     `${CONFIG.SCORM_URL}?course_id=${courseId}&module_id=${mId}&user_id=${authBroker?.payload?.user?.user_id}&token=${localStorage.getItem(SessionKeys.API_TOKEN_BROKER)}`}
                        // src="https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=CSCD_72&module_id=624ed8bc5cf45c05dd4bf234"
                        // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657162/index.html"
                        src={scormURL}
                        allowFullScreen={true}
                    /></div>)
                :
                    !_.isEmpty(moduleDataInfo) && reload ?
                    (moduleDataInfo?.rsp_scromdata.map((module) => {
                        if (module?.type?.toLowerCase() === "url") {
                            return (
                                <div className="scrom-wrapr"><iframe
                                    key={mId}
                                    type="text/html"
                                    className="w-100 ms-auto me-auto"
                                    id="scorm_player"
                                    height={iframeHeight}
                                    //style={{ minHeight: iframeMinHeight, width: "70%", margin: "0 auto" }}
                                    frameBorder="0"
                                    marginHeight="0"
                                    marginWidth="0"
                                    onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                    ref={refer}
                                    // src="https://jba-learn-dev.niit-mts.com/scorm_player.php?course_id=jbc_hr_od&module_id=jbc_hr_od_m1"
                                    // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657078/launch.html?crscd=CSCD_58"
                                    // src={`https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=${courseId}&module_id=${mId}&username=${username}`}
                                    // src={source === 'broker' ?
                                    //     `${CONFIG.SCORM_URL_BROKER}?course_id=${courseId}&module_id=${mId}&email=${authBroker?.payload?.user?.email}&user_id=${authBroker?.payload?.user?.user_id}&output=embed` :
                                    //     `${CONFIG.SCORM_URL}?course_id=${courseId}&module_id=${mId}&user_id=${authBroker?.payload?.user?.user_id}&token=${localStorage.getItem(SessionKeys.API_TOKEN_BROKER)}`}
                                    // src="https://rsplearning-dev.niit-mts.com/public/scorm_player?course_id=CSCD_72&module_id=624ed8bc5cf45c05dd4bf234"
                                    // src="https://iv17-rsp-dev.niit-mts.com/knowledge/plo_content/ORG235690/COURSE657162/index.html"
                                    src={scormURL}
                                    allowFullScreen={true}
                                /></div>
                            )
                        } else if (module?.type?.toLowerCase() === "mp4" || module?.type?.toLowerCase() === "mov") {
                            setLoadFalse(true)
                            // console.log("it reached mp4")
                            return (
                                <>
                                    {isLoad
                                        ? <></> :

                                        <div className="video-fullbox w-100">
                                            <div className="search__input">
                                                <div className="img-box_RP">
                                                    <div className="video-full">

                                                        <VideoPlayer
                                                            className="img-videosec learn_image-card"
                                                            controls={true}
                                                            // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
                                                            src={module.url}
                                                            width="720"
                                                            height="420"
                                                            autoPictureInPicture={true}
                                                            // poster={module.}
                                                            // onLoad={setLoadFalse}
                                                            fluid={true}
                                                            inline={false}
                                                            pictureInPictureToggle={true}
                                                            type={module.type.toLowerCase() === "mp4" ? "video/mp4" : "video/mov"}
                                                            onReady={(player) => { onPlayerReady(player, module.type) }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    }
                                </>
                            )
                        }else if (module?.type?.toLowerCase() === "mp3") {
                            setLoadFalse(true)
                            // console.log("it reached mp4")
                            return (
                                <>
                                    <AudioPlayerComp setLoadFalse={setLoadFalse} link={module.url} moduleId={mId} courseId = {courseId} watch_time={moduleData?.watch_time}/>
                                </>
                            )
                        } else if (module.type === "pdf" || assetId === "4") {
                         setLoadFalse();
                            return (

                                assetId==="4"?<div className="pdf-view-page" style={{ height: "1200px" }}>

                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={assetId==="4"?moduleInfo?.external_link:CONFIG.API_URL_BROKER_ADMIN + "/pdfview/?id=" + mId + "&u_token=" + localStorage.getItem(SessionKeys.API_TOKEN_BROKER)} title={module.title} height="100%" width="100%" />
                                </div>:
                                <PDFViewer fileUrl={module.url}/>
                            )
                        } else if (module.type === "xlsx") {
                            return (
                                <div className="pdf-view-page" style={{ height: "700px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${module.url}`}
                                        title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else if (module.type === "docx") {
                            return (
                                <div className="pdf-view-page" style={{ height: "700px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${module.url}`}
                                        title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else if (module.type === "pptx") {
                            return (
                                <div className="pdf-view-page" style={{ height: "700px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${module.url}`}
                                        title={module.title} height="100%" width="100%" />
                                </div>
                            )
                        } else if (module.type === "external_link"){
                         setLoadFalse();
                         if(module?.url?.includes("youtube.com")){
                         return <YoutubePlayer  url = {module?.url} onProgress ={onProgress} onComplete={onComplete} watch_time={moduleData?.watch_time} />
                         } else if(module?.url?.includes("vimeo.com")){
                         return <VimeoPlayer  vimeoUrl = {module?.url} onProgress ={onProgress} onComplete={onComplete} watch_time={moduleData?.watch_time} />
                         }else if(module?.url?.includes(".pdf")){
                         return <PDFViewer fileUrl={module.url}/>
                         }
                         else{  
                          return <div className="pdf-view-page" style={{ height: "1200px" }}>
                                    <iframe
                                        className="w-100"
                                        onLoad={() => { window.scrollTo(0, 0); setLoadFalse(); markProgress(); }}
                                        src={module?.url} title={module.title} height="100%" width="100%" />
                                </div> }
                        } else {
                            <div className="container">
                                <div className="row" >
                                    <div className="col-md-12" >
                                        <div className="video-fullbox w-100">
                                            <div className="search__input">
                                                <div className="img-box_RP">
                                                    <div className="video-full">
                                                        <VideoPlayer
                                                            className="img-videosec learn_image-card"
                                                            controls={true}
                                                            // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
                                                            src={module.url}
                                                            width="720"
                                                            height="420"
                                                            autoPictureInPicture={true}
                                                            // poster={module.}
                                                            // onLoad={setLoadFalse}
                                                            fluid={true}
                                                            inline={false}
                                                            pictureInPictureToggle={true}
                                                            onReady={(player)=> {onPlayerReady(player, module.type)}}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    })
                    ) : ''
            }
        </div>
    )
}